import React from 'react';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Card, Form, Button } from 'react-bootstrap';
import '../App.css';

const CancelAppointmentUI = ({
    appointments,
    selectedAppointments,
    setSelectedAppointments,
    handleSubmit
}) => {
    const toggleAppointmentSelection = (appointment) => {
        const isSelected = selectedAppointments.some(a => a.id === appointment.id);
        if (isSelected) {
            setSelectedAppointments(prev => prev.filter(a => a.id !== appointment.id));
        } else {
            setSelectedAppointments(prev => [...prev, appointment]);
        }
    };
    
    return (
        <Container className="mt-5">
            <Row className="justify-content-center">
                <Col md={8}>
                    <Card>
                        <Card.Header className="dark-green-header">
                            <h4 className="mb-0">Cancel Appointment Form</h4>
                        </Card.Header>
                        <Card.Body>
                            <Form onSubmit={(e) => e.preventDefault()}>
                                <Form.Group>
                                    <Form.Label>Select appointments to cancel:</Form.Label>
                                    <div>
                                        {appointments.map((appointment) => (
                                            <Form.Check
                                                key={appointment.id}
                                                //Youssouf did the code below
                                                type="checkbox" 
                                                label={`Course: ${appointment.name} - Course Num: ${appointment.courseNum} - Instructor: ${appointment.proctor}`}
                                                checked={selectedAppointments.some(a => a.id === appointment.id)}
                                                onChange={() => toggleAppointmentSelection(appointment)}
                                            />
                                        ))}
                                    </div>
                                </Form.Group>

                                <Form.Group className="mt-4">
                                    <Button
                                        variant="custom"
                                        type="button"
                                        block
                                        onClick={handleSubmit}
                                    > 
                                        Cancel Selected Appointments 
                                    </Button>

                                    <Link to="/studentdashboard" className="btn btn-secondary btn-block mt-2">
                                        Back to Dashboard 
                                    </Link>
                                </Form.Group>
                            </Form>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default CancelAppointmentUI;
